import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import { useAuth } from '../context/AuthContext';
import { track } from '../analytics/track';
import { forgetIntent, pendingIntent } from './signupIntent';
import { safeRedirect } from '../utils/safeRedirect';

const NEW_ACCOUNT_MS = 15 * 60 * 1000;

/**
 * A new account that lands on the bare AI Agent page although its sign-up was going somewhere
 * else (AI Clipping, an idea, a project an email linked to) is sent on to it, once. Google One
 * Tap and a sign-in finished in another tab both skip the sign-up page's own redirect.
 */
export default function SignupIntentRecovery() {
  const { isAuthenticated } = useAuth();
  const { user } = useUser();
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) return;
    const to = pendingIntent();
    if (!to) return;
    const here = pathname + search;
    if (here === to || pathname.startsWith('/signup')) {
      if (here === to) forgetIntent();
      return;
    }
    const created = user?.createdAt ? new Date(user.createdAt).getTime() : 0;
    if (pathname !== '/ai-agent' || search || Date.now() - created > NEW_ACCOUNT_MS) return;
    forgetIntent();
    track('signup_intent_recovered', { to: to.split('?')[0] });
    navigate(safeRedirect(to), { replace: true });
  }, [isAuthenticated, user, pathname, search, navigate]);

  return null;
}
